module.exports = __webpack_public_path__ + "img/email-design-image.3b4d5e9.png";